import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpaySbpEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/sbp/`
        this.webApi = new WebApi()
    }

    async getByOrderId (orderId) {
        return this.webApi.get(`${this.url}getByOrderId/${orderId}`)
    }
}
